export default "__VITE_PUBLIC_ASSET__6bc3f93c__"